<template>
  <div class="actions">
    <button v-if="!hideSave" class="button is-primary" @click="save" :disabled="disabled()">
      <span class="icon">
        <i class="fal fa-save"></i>
      </span>
      <span>{{ saveText }}</span>
    </button>

    <button v-if="displaySaveAndSelect" class="button is-primary" @click="saveAndSelect" :disabled="disabled()">
      <span class="icon">
        <i class="fal fa-check"></i>
      </span>
      <span>Spara och välj</span>
    </button>

    <button v-if="!hideClose" class="button" @click="closePanel" :disabled="disabled()">
      <span class="icon">
        <i class="fal fa-ban"></i>
      </span>
      <span>{{ closeText }}</span>
    </button>

  </div>
</template>
<script>

export default {
  props: {
    saveLabel: String,
    closeLabel: String,
    hideSave: Boolean,
    hideClose: Boolean,
    displaySaveAndSelect: Boolean,
    storeName: String
  },

  computed: {
    saveText: function () {
      return this.saveLabel ? this.saveLabel : 'Spara'
    },

    closeText: function () {
      return this.closeLabel ? this.closeLabel : 'Stäng'
    }
  },

  methods: {
    disabled () {
      if (this.storeName) {
        return this.$store.state[this.storeName].all.saving
      }

      return false
    },

    save () {
      this.$parent.$emit('emitSave')
    },
    saveAndSelect () {
      this.$parent.$emit('emitSaveAndSelect')
    },
    closePanel () {
      this.$parent.$emit('closePanel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ModalLayoutButtons.vue